var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui row"},[_c('div',{staticClass:"ui three wide column"},[_c('Dashboard',{attrs:{"course":_vm.course,"checkpoints":_vm.checkpoints,"languages":_vm.languages,"selectedLanguage":_vm.selectedLanguage}})],1),_vm._v(" "),_c('div',{staticClass:"ui thirteen wide column"},[_c('ContentContainer',{attrs:{"course":_vm.course,"checkpoint":_vm.checkpoint}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d93645e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 248
// module chunks = 0